// Filter chips for son product grids/carousels.
//
// MARKUP CONTRACT (see Son_Product_Grid)
//   <nav data-son-filter-bar>
//     <button data-son-filter="*">Show all</button>
//     <button data-son-filter="some-slug">…</button>
//   </nav>
//   …followed, under the same parent, by items carrying
//   data-son-filter-terms="slug-a slug-b". Filtered-out items (or their
//   .swiper-slide box) get .son-filter-hidden; Swiper instances are told to
//   update so a filtered carousel re-lays-out its track.
//
// The chosen filter is kept in ?filter=<slug> (WP Rocket caches each value, see
// son_filter_rocket_query_strings) and applies to every bar on the page; a bar
// without that chip shows all.

const PARAM = 'filter';

function applyFilter(bar, filter) {
    const tab = bar.querySelector(`[data-son-filter="${CSS.escape(filter)}"]`)
        || bar.querySelector("[data-son-filter='*']");
    const shown = tab ? tab.dataset.sonFilter : '*';

    bar.querySelectorAll('[data-son-filter]').forEach((other) => {
        const active = other === tab;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const scope = bar.parentElement;
    scope.querySelectorAll('[data-son-filter-terms]').forEach((item) => {
        const terms = (item.dataset.sonFilterTerms || '').split(/\s+/);
        const show = shown === '*' || terms.includes(shown);
        const box = item.closest('.swiper-slide') || item;
        box.classList.toggle('son-filter-hidden', !show);
    });

    scope.querySelectorAll('.swiper').forEach((el) => {
        if (el.swiper) {
            el.swiper.update();
        }
    });
}

function rememberFilter(filter) {
    const url = new URL(window.location.href);
    if (filter === '*') {
        url.searchParams.delete(PARAM);
    } else {
        url.searchParams.set(PARAM, filter);
    }
    window.history.replaceState(window.history.state, '', url);
}

function bindFilterBar(bar) {
    if (bar.dataset.sonFilterReady) {
        return;
    }
    bar.dataset.sonFilterReady = 'true';

    const fromUrl = new URLSearchParams(window.location.search).get(PARAM);
    if (fromUrl) {
        applyFilter(bar, fromUrl);
    }

    bar.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-son-filter]');
        if (!tab) {
            return;
        }

        // clicking the active chip deselects it -> back to show-all
        const filter = tab.classList.contains('is-active') ? '*' : tab.dataset.sonFilter;

        document.querySelectorAll('[data-son-filter-bar]').forEach((each) => applyFilter(each, filter));
        rememberFilter(filter);
    });
}

function initFilterBars(root = document) {
    root.querySelectorAll('[data-son-filter-bar]').forEach(bindFilterBar);
}

document.addEventListener('DOMContentLoaded', () => initFilterBars());

// re-bind after Elementor editor re-renders an element
window.addEventListener('elementor/frontend/init', () => {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/global', ($element) => {
            initFilterBars($element[0] || document);
        });
    }
});
